"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyNegative = void 0;
const applyNegative = (data, isNegative) => {
  if (isNegative) {
    const negative = {
      personalData: !data.personalData,
      contact: !data.contact,
      marketingOriflame: !data.marketingOriflame,
      marketingExternal: !data.marketingExternal,
      publication: !data.publication,
      newsletters: !data.newsletters,
      uplineLeaderData: !data.uplineLeaderData,
      uplineLeaderBrowse: !data.uplineLeaderBrowse,
      orderHistory: !data.orderHistory,
      marketingConsultant: !data.marketingConsultant,
      blockGuaranteeOrdering: !data.blockGuaranteeOrdering,
      optedOutOfSponsorSelect: !data.optedOutOfSponsorSelect
    };
    return negative;
  }
  return data;
};
exports.applyNegative = applyNegative;